import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {catchError, EMPTY, Observable} from "rxjs";
import {switchMap, take} from "rxjs/operators";
import {CodebookService, EventService} from "@services";
import {EventItem, FindEventsRequest, Lookups} from "@model";
import {ORGANISER_EVENTS} from "../app-routing.module";
import {inject} from "@angular/core";
import {ResolveFn, RouterStateSnapshot} from "@angular/router";

export const EventListResolver: ResolveFn<Observable<EventItem[]> |
  Promise<EventItem[]> | EventItem[]> | any =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   router: Router,
   codebookService: CodebookService = inject(CodebookService),
   eventService: EventService = inject(EventService))
    : Observable<EventItem[]> |
    Promise<EventItem[]> | EventItem[] | any => {
    let organiserId = route.queryParams['organiser'] ? +route.queryParams['organiser'] : undefined;
    let statusId = route.queryParams['status'] ? +route.queryParams['status'] : undefined;
    let name = route.queryParams['name'] ? route.queryParams['name'] : undefined;
    return codebookService['eventStatuses'].value
      .pipe(
        take(1),
        switchMap((statuses: Lookups[]) => {
          const isValidStatus = !statusId || statuses.some((status) => status.id === statusId);

          if (!isValidStatus) {
            router.navigate([ORGANISER_EVENTS]);
            return EMPTY;
          } else {
            return eventService.fetchAdminEvents(
              FindEventsRequest.createEventPageFilter(1, {
                status: statusId,
                organiserId: organiserId,
                name: name,
              }));
          }
        }),
        catchError(() => {
          router.navigate([ORGANISER_EVENTS]);
          return EMPTY;
        })
      );
  }


